module.exports = __webpack_public_path__ + "img/CarFinance247_logo_purple.c00877d2.svg";